import React from 'react';
import { ArrowTopRightFilled } from '@tag/tag-icons';

import styles from './arrow-icon.module.scss';

export default function ArrowIcon() {
  return (
    <div className={styles.wrapper}>
      <ArrowTopRightFilled
        accent="teal"
        size="20"
      />
    </div>
  );
}
